import styled from '@emotion/styled';

export const SadaServiceQuestionFormModal = styled.div``;
